module.exports = __webpack_public_path__ + "media/src/web/images/upsell-item-modal/bag-style-1-b8d2f3c4c4827ba8b8089fcc9fc5b25c.png";